export default class ClipUtil {

  static getParametersFromClipElement(clipElement) {

    return {
      menuType: clipElement.getAttribute("data-menu-type"),
      serviceId: parseInt(clipElement.getAttribute("data-service-id")),
      contentType: clipElement.getAttribute("data-contents-type"),
      contentDetailType: clipElement.getAttribute("data-contents-detail-type"),
      contentKey: clipElement.getAttribute("data-clip-url"),
      contentTitle: clipElement.getAttribute("data-clip-title"),
      contentUrl: clipElement.getAttribute("data-clip-url"),
      contentImageUrl: clipElement.getAttribute("data-clip-image-url"),
      itemPageShown: clipElement.getAttribute("data-clip-item-page-shown"),
    }

  }

}